import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getTrendData = api(async function getTrendData(measure) {
    return query(
        gql`
            query getTrendData($measure: String!) {
                getTrendData(measure: $measure)
            }
        `,
        { measure },
        { returns: "getTrendData" }
    )
})
